import { atom } from "recoil";

const sortAtom = atom({
    key: 'sortAtom',
    default: 'DEFAULT'
});

export default sortAtom;
